import {
    Divider,
    Grid,
    IconButton,
    Paper,
    Toolbar,
    Typography,
    useTheme,
} from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { Pagination } from "@mui/material";
import RbcV2ResultsSearchTermsPanel from "./ClassifierBuilderV2SearchTermsPanel";
import { useNavigate } from "react-router";
import AcxButton from "components/UI/AcxButton";
import { useStore } from "utils/useStore";
import { ClassifierBuilderV2Store } from "../../Stores/ClassifierBuilderV2Store";
import RbcV2ResultsListWrapper from "./ClassifierBuilderV2ResultsListWrapper";

const ClassifierBuilderV2Results = observer(() => {
    const theme = useTheme();
    const store = useStore(ClassifierBuilderV2Store);
    const navigate = useNavigate();
    const [resTitleCount, setResTitleCount] = React.useState<number>(0);

    const onBack = () => {
        navigate(-1);
        store.setEstimatedTotalResCount(0);
    };

    const onConversationExplorer = () => {
        navigate(`/app/conversations/`);
    };

    const totalPages = Math.ceil((store.estimatedTotalResCount ?? 0) / 10);
    const haveResults =
        !!store?.rbcConversationResults?.length || store.pageNumber !== 1;
    const rbcConversationResultsPagination = (
        <Grid
            container
            item
            xs={12}
            sx={{
                bottom: 0,
                position: "sticky",
                display: "flex",
                alignItems: "center",
                maxHeight: "120px",
                backgroundColor: "#fff",
                paddingTop: theme.spacing(5),
                paddingBottom: theme.spacing(5),
                paddingRight: theme.spacing(2.5),
                borderTop: "1px solid var(--neutral-100, #E5E7EB)",
            }}
        >
            <Grid
                container
                item
                xs={12}
                justifyContent="flex-end"
                alignItems="center"
            >
                <Grid item>
                    <Pagination
                        variant="outlined"
                        color="secondary"
                        count={totalPages > 10 ? 10 : totalPages}
                        page={store.pageNumber}
                        onChange={(evt, val) => {
                            store.setPageNumberAndGetClassifierResults(val);
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );

    React.useEffect(() => {
        setResTitleCount(
            store.estimatedTotalResCount > 100
                ? 100
                : store.estimatedTotalResCount,
        );
    }, [store.estimatedTotalResCount]);

    return (
        <Grid container direction="column">
            <Grid item style={{ width: "100%" }}>
                <Toolbar
                    sx={{
                        borderBottom: "0.5px solid var(--neutral-100, #E5E7EB)",
                        backgroundColor: "white",
                        paddingLeft: {
                            xs: "4%",
                            sm: "4%",
                            md: "5%",
                            lg: "7%",
                            xl: "12%",
                        },
                        paddingRight: {
                            xs: "3%",
                            sm: "3%",
                            md: "6%",
                            lg: "8%",
                            xl: "13.5%",
                        },
                    }}
                >
                    <Grid
                        container
                        item
                        xs={12}
                        direction="row"
                        wrap={"nowrap"}
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Grid item container alignItems="center">
                            <Grid item>
                                <IconButton onClick={onBack} size="large">
                                    <ArrowBack
                                        fontSize={"inherit"}
                                        color={"inherit"}
                                    />
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Typography
                                    sx={{
                                        fontSize: "18px",
                                        fontWeight: theme.typography.fontWeightBold,
                                        color: "black",
                                        whiteSpace: "nowrap",
                                        display: "flex",
                                        padding: theme.spacing(2),
                                    }}
                                >
                                    Classifier Results
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid
                            item
                            container
                            direction="row"
                            wrap={"nowrap"}
                            alignItems="center"
                            justifyContent="flex-end"
                            style={{ maxWidth: "400px" }}
                        >
                            <AcxButton
                                fullWidth
                                color="primary"
                                sx={{
                                    backgroundColor: "white",
                                    color: theme.palette.black.main,
                                    border: "1px solid #E4E4E7",
                                    maxWidth: "186px",
                                    marginRight: "8px",
                                    borderRadius: "4px",
                                    height: "36px",
                                    "&:hover": {
                                        color: "white",
                                    },
                                }}
                                onClick={() => navigate(`../`)}
                            >
                                Return to Classifier List
                            </AcxButton>
                            <AcxButton
                                fullWidth
                                color="primary"
                                sx={{
                                    maxWidth: "183px",
                                    marginLeft: "0px",
                                    height: "36px",
                                }}
                                onClick={onConversationExplorer}
                            >
                                Conversation Explorer
                            </AcxButton>
                        </Grid>
                    </Grid>
                </Toolbar>
            </Grid>
            <Grid
                item
                container
                direction="row"
                wrap="nowrap"
                sx={{
                    paddingLeft: {
                        xs: "calc(100% - 98%)",
                        sm: "calc(100% - 98%)",
                        md: "calc(100% - 91%)",
                        lg: "calc(100% - 91%)",
                        xl: "calc(100% - 91%)",
                    },
                    paddingRight: {
                        xs: "calc(100% - 98%)",
                        sm: "calc(100% - 98%)",
                        md: "calc(100% - 91%)",
                        lg: "calc(100% - 91%)",
                        xl: "calc(100% - 91%)",
                    },
                    paddingTop: theme.spacing(3),
                    height: "calc(100% - 84px)",
                    justifyContent: "center",
                }}
            >
                <RbcV2ResultsSearchTermsPanel onBack={onBack} />
                <Grid item xs={8}>
                    <Paper
                        sx={{
                            minHeight: "77vh",
                            maxHeight: "77vh",
                            overflowY: "auto",
                        }}
                    >
                        <Grid
                            item
                            xs={12}
                            sx={{
                                position: "sticky",
                                top: 0,
                                zIndex: 2,
                                width: "100%",
                                backgroundColor: "#fff",
                            }}
                        >
                            <Grid
                                item
                                container
                                justifyContent="flex-start"
                                direction="row"
                                alignItems="center"
                                wrap="nowrap"
                            >
                                <Typography
                                    sx={{
                                        fontSize: "18px",
                                        fontWeight: theme.typography.fontWeightBold,
                                        color: "black",
                                        whiteSpace: "nowrap",
                                        display: "flex",
                                        paddingTop: theme.spacing(3),
                                        paddingLeft: theme.spacing(3),
                                        paddingRight: theme.spacing(1),
                                        paddingBottom: theme.spacing(2),
                                    }}
                                >
                                    {`Results`}
                                </Typography>{" "}
                                {!store.resultsLoading &&
                                store.estimatedTotalResCount ? (
                                    <Typography
                                        sx={{
                                            fontSize: "12px",
                                            fontWeight: theme.typography.fontWeightBold,
                                            color: "black",
                                            whiteSpace: "nowrap",
                                            display: "flex",
                                            paddingTop: theme.spacing(3.1),
                                            paddingBottom: theme.spacing(2),
                                        }}
                                    >
                                        {`(  Showing ${resTitleCount} of ${store.estimatedTotalResCount} total results )`}
                                    </Typography>
                                ) : (
                                    <></>
                                )}
                            </Grid>

                            <Divider />
                        </Grid>

                        <Grid
                            item
                            container
                            sx={{
                                padding: theme.spacing(3),
                                paddingBottom: "0px",
                                minHeight: "calc(77vh - 19vh)",
                            }}
                        >
                            <RbcV2ResultsListWrapper />
                        </Grid>

                        {haveResults && rbcConversationResultsPagination}
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
    );
});

export default ClassifierBuilderV2Results;
